@if (offer) {
    <div class="offer-container">
        @if (offer.offer_status === 'ACCEPTED' && !allDocumentsSigned) {
            <div class="doc-tabs">
                <button class="doc-tab" [class.active]="activeTab === 'details'" (click)="activeTab = 'details'">
                    Offer Details
                </button>
                <button class="doc-tab" [class.active]="activeTab === 'unsigned'" (click)="activeTab = 'unsigned'">
                    Unsigned Documents
                </button>
            </div>
        }
        <!-- Offer Details Tab -->
        @if (activeTab === 'details' || allDocumentsSigned) {
            <div class="offer-card primary">
                <div class="value">
                    <div class="label">Offer Amount</div>
                    {{ offer.offer_amount | currency }}
                </div>
                @if (offer.cover_letter) {
                    <div class="cover-letter-doc">
                        <div class="doc-info">
                            <hugeicons-icon [icon]="fileIcon" [size]="20"></hugeicons-icon>
                            <span class="doc-name">Cover Letter</span>
                        </div>
                        <div class="doc-actions">
                            <button class="btn-icon" title="View" (click)="viewCoverLetter.emit()" [disabled]="coverLetterViewing">
                                @if (coverLetterViewing) {
                                    <span class="spinner"></span>
                                } @else {
                                    <hugeicons-icon [icon]="viewIcon" [size]="16"></hugeicons-icon>
                                }
                            </button>
                            <button class="btn-icon" title="Download" (click)="downloadCoverLetter.emit()" [disabled]="coverLetterDownloading">
                                @if (coverLetterDownloading) {
                                    <span class="spinner"></span>
                                } @else {
                                    <hugeicons-icon [icon]="downloadIcon" [size]="16"></hugeicons-icon>
                                }
                            </button>
                        </div>
                    </div>
                }
            </div>
            <div class="details-section">
                <div class="detail-group">
                    <label>Offer Issued At</label>
                    <div class="text-content">{{ offer.offer_issued_at | date:'medium' }}</div>
                </div>
                <div class="status-row">
                    <span class="status-label">Status</span>
                    <span class="status-badge" [ngClass]="getStatusClass(offer.offer_status)">
                        {{ offer.offer_status }}
                    </span>
                </div>
                <div class="detail-group">
                    <label>Instructions</label>
                    <div class="text-content">{{ offer.instructions || 'No instructions provided.' }}</div>
                </div>
            </div>
            @if (signedDocuments.length > 0) {
                <div class="signed-documents-section">
                    <div class="section-title">Signed Documents</div>
                    <div class="documents-list">
                        @for (doc of signedDocuments; track doc) {
                            <div class="document-item">
                                <div class="doc-info">
                                    <hugeicons-icon [icon]="fileIcon" [size]="20"></hugeicons-icon>
                                    <span class="doc-name">{{ doc.document_type || doc.file_name_signed }}</span>
                                </div>
                                <a [href]="getSignedDocumentUrl(doc)" target="_blank" class="btn-icon" title="View">
                                    <hugeicons-icon [icon]="viewIcon" [size]="16"></hugeicons-icon>
                                </a>
                            </div>
                        }
                    </div>
                </div>
            }
        }
        <!-- Unsigned Documents Tab (only after accepted and not all signed) -->
        @if (activeTab === 'unsigned' && offer.offer_status === 'ACCEPTED' && !allDocumentsSigned) {
            @if (allSignableDocuments.length > 0) {
                <div class="documents-list">
                    @for (doc of allSignableDocuments; track doc) {
                        <div class="document-item" [class.signed]="!!doc.file_name_signed">
                            <div class="doc-info">
                                @if (doc.file_name_signed) {
                                    <hugeicons-icon [icon]="checkCircleIcon" [size]="20" class="signed-icon"></hugeicons-icon>
                                } @else {
                                    <hugeicons-icon [icon]="fileIcon" [size]="20"></hugeicons-icon>
                                }
                                <span class="doc-name">{{ doc.document_type || doc.file_name_unsigned }}</span>
                            </div>
                            <div class="doc-actions">
                                <button class="btn-icon" title="View" (click)="onViewDocPdf(doc)" [disabled]="viewingDocIndex === getDocIndex(doc)">
                                    @if (viewingDocIndex === getDocIndex(doc)) {
                                        <span class="spinner"></span>
                                    } @else {
                                        <hugeicons-icon [icon]="viewIcon" [size]="16"></hugeicons-icon>
                                    }
                                </button>
                                <button class="btn-icon" title="Download" (click)="onDownloadDocPdf(doc)" [disabled]="downloadingDocIndex === getDocIndex(doc)">
                                    @if (downloadingDocIndex === getDocIndex(doc)) {
                                        <span class="spinner"></span>
                                    } @else {
                                        <hugeicons-icon [icon]="downloadIcon" [size]="16"></hugeicons-icon>
                                    }
                                </button>
                            </div>
                        </div>
                    }
                </div>
            } @else {
                <div class="empty-tab">No documents available.</div>
            }
        }
    </div>
} @else {
    <div class="empty-state">
        <p>No active offer found for this case.</p>
    </div>
}
